import { render, staticRenderFns } from "./FormServer1Streamax.vue?vue&type=template&id=4e87a716&scoped=true&"
import script from "./FormServer1Streamax.vue?vue&type=script&lang=ts&"
export * from "./FormServer1Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormServer1Streamax.vue?vue&type=style&index=0&id=4e87a716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e87a716",
  null
  
)

export default component.exports